'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { t } from '@/i18n/translations'

export default function NotFound() {
    const pathname = usePathname()
    const lang = pathname?.startsWith('/ru') ? 'ru' : 'en'
    const homeUrl = `/${lang}`

    const common = t(lang, 'common')
    const ui = t(lang, 'staticPagesUi').error

    return (
        <section className="nf-wrap">
            <div className="nf">
                <p className="nf-kick">{ui.kicker}</p>

                <h1>{common.notFound}</h1>

                <p className="nf-lead">{common.notFoundDesc}</p>

                <div className="nf-acts">
                    <button className="pri" onClick={() => window.history.back()}>{common.back}</button>
                    <Link className="sec" href={homeUrl}>{common.home}</Link>
                </div>

                <div className="nf-pop">
                    <span className="lbl">{ui.popularLabel}</span>
                    <div className="nf-links">
                        {/* было Блог / пустые Таблицы / Контакты — ни одного пути к деньгам (обход 01.10.2026);
                            аренда авто в Черногории — 76% дохода */}
                        <Link href={`${homeUrl}/montenegro/transport`}>{ui.carRental}</Link>
                        <Link href={`${homeUrl}/montenegro/esim`}>{ui.esim}</Link>
                        <Link href={`${homeUrl}/montenegro/tours`}>{ui.tours}</Link>
                        <Link href={`${homeUrl}/blog`}>{ui.blog}</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
